/**
 * The user's local calendar date, normalised to UTC midnight so it compares
 * cleanly against date-only field values (which parse as UTC midnight).
 * Team members are spread across timezones (UK, Pakistan): "overdue",
 * "days at stage" and sprint rollover must flip at each user's LOCAL
 * midnight, not UTC's.
 */
export function localToday(now: Date = new Date()): Date {
  return new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()))
}

export const DAY_MS = 86_400_000

/** Parse a field value to a Date; date-only strings are treated as UTC midnight
 *  for stable maths (matching how date-only field values parse). */
export function toDate(value: string): Date {
  return new Date(value.length === 10 ? value + 'T00:00:00Z' : value)
}
